import styled, { keyframes } from 'styled-components';

export const BAR_COUNT = 5;
const DURATION = 1;
const STAGGER = 0.08;
const PULSE = 0.4;

// Each bar shares this single timeline (relative to DURATION) and is offset with a
// positive animation-delay, so bar 0 pulses first and bar 5 pulses last (left to right).
// The pulse only occupies the first PULSE seconds of that timeline — once bar 5 has
// finished, every bar sits flat together for the remainder of DURATION before the
// whole sweep restarts from bar 0.
const RISE = ((PULSE / 2 / DURATION) * 100).toFixed(3);
const FALL = ((PULSE / DURATION) * 100).toFixed(3);

const wave = keyframes`
  0% {
    height: 30%;
  }

  ${RISE}% {
    height: 100%;
  }

  ${FALL}%,
  100% {
    height: 30%;
  }
`;

export const Container = styled.div<{ $size: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ $size }) => $size}px;
  gap: 3px;
`;

export const Bar = styled.div<{ $size: number; $color?: string; $index: number }>`
  width: ${({ $size }) => Math.ceil($size / 10)}px;
  height: 30%;
  border-radius: 4px;
  background-color: ${({ $color, theme }) => $color || theme.primary};
  animation: ${wave} ${DURATION}s ease-in-out infinite;
  animation-delay: ${({ $index }) => ($index * STAGGER).toFixed(3)}s;
`;
